import { withViewData } from "../App/ViewData"
import { TripDataView } from "./Trip/DataView"
import type { TripDataProps, TripViewProps } from "./Trip/Params"
import { TripViewUI } from "./Trip/TripViewUI"

export { TripViewData } from "./Trip/Context"

const TripDataViewWithUI = withViewData<TripDataProps>({
  acquire: TripDataView,
  ui: TripViewUI,
});

export function TripView({ children, ...props }: TripViewProps) {
  return <TripDataViewWithUI {...props} tripChildren={children} />;
}
